import React from 'react';
import PropTypes from 'prop-types';

import InfoSwiper from '../../ui/InfoSwiper';
import analytics from '../../../modules/analytics';

import './PaymentsEducationSwiper.scss';

/**
 * The payments education swiper
 */
export default class PaymentsEducationSwiper extends React.Component {
  static propTypes = {
    renderContainer: PropTypes.object,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    renderContainer: null,
    /** callback when swiper closes */
    onClose: () => {},
  };

  componentWillUnmount() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    return (
      <InfoSwiper
        renderContainer={this.props.renderContainer}
        className="payments-education-swiper"
        onSlideViewed={pageNo => analytics.track('pro_payments_education_swiper_viewed', {
          page_number: pageNo + 1,
        })}
        onDismissed={pageNo => analytics.track('pro_payments_education_swiper_dismissed', {
          page_number: pageNo + 1,
        })}
      >
        <section className="slide-1 slide-content">
          <h1>Learn how to charge clients through StyleSeat</h1>
          <p>
            Want to give clients a seamless experience and make more money?
            Swipe away!
          </p>
        </section>
        <section className="with-background slide-content">
          <h1>
            Securely Store <br /> Credit Cards
          </h1>
          <p>
            <span className="secure icon" />
            <span>
              Securely store credit cards for quick and easy checkout. Never
              have to manually enter a card for that client again.
            </span>
          </p>
          <p>
            <span className="checkmark icon" />
            <span>Hit checkout from the appt. details.</span>
          </p>
          <p>
            <span className="credit-card icon" />
            <span>Enter your client&apos;s payments info and save.</span>
          </p>
        </section>
        <section className="with-background slide-content">
          <h1>You Have Control</h1>
          <p>
            <span className="price-tag icon" />
            <span>Easily adjust the total cost.</span>
          </p>
          <p>
            <span className="transactions icon" />
            <span>
              Clients are only charged after they tip & sign and you tap&nbsp;
              <em>charge</em>.
            </span>
          </p>
          <p>
            <span className="refund icon" />
            <span>You have the power to refund or offer discounts.</span>
          </p>
        </section>
        <section className="with-background slide-content">
          <h1>Clients Love It</h1>
          <p>
            <span className="percentage icon">+40%</span>
            <span>
              Clients tip an average of 40% more when they pay through
              StyleSeat.
            </span>
          </p>
          <p>
            <span className="receipt icon" />
            <span>
              Itemized receipts are sent automatically with a friendly reminder
              to rebook and leave a review.
            </span>
          </p>
        </section>
        <section className="with-background slide-content">
          <h1>Get Paid Fast</h1>
          <p>
            <span className="instant-payment icon" />
            <span>Get paid instantly, including weekends and holidays.</span>
          </p>
          <p>
            <span className="deposit icon" />
            <span>
              Or, get next-business-day deposits for&nbsp;<strong>free</strong>.
            </span>
          </p>
          <p>
            <span className="settings icon" />
            <span>
              You can adjust your deposit schedule and see your charge history
              in the&nbsp;<em>Deposits</em>&nbsp;tab.
            </span>
          </p>
        </section>
      </InfoSwiper>
    );
  }
}
